export const correctionFields = [
  { value: "texts", label: "Etiket metni" },
  { value: "customerRequest", label: "Satış talimatı" },
  { value: "packaging", label: "Uygulanacak yer" },
  { value: "requestedPrintQuantity", label: "Etiket adedi" },
  { value: "referenceNotes", label: "Ek not" },
  { value: "other", label: "Diğer" },
];

export function correctionFieldLabel(field: string): string {
  const legacy: Record<string, string> = { language: "Dil", widthMm: "En", heightMm: "Boy" };
  return correctionFields.find(item => item.value === field)?.label ?? legacy[field] ?? field;
}
